// A tiny version label in the bottom corner of every page: the build date and
// the commit it was built from ("+" when built with uncommitted changes).
// web/build.ts fills in OMNIU_VERSION.

declare const OMNIU_VERSION: string;

const tag = document.createElement('div');
tag.textContent = OMNIU_VERSION;
tag.setAttribute('aria-hidden', 'true');
tag.style.cssText = 'position:fixed;right:6px;bottom:3px;z-index:2147483647;font:9px/1 ui-monospace,monospace;color:#888;opacity:.45;pointer-events:none;user-select:none';
document.body.appendChild(tag);
